var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46166 14.9841L10.3199 12.9206C10.824 11.7087 11.9636 10.8808 13.2719 10.7759L15.4996 10.5973C15.9429 10.5617 16.1227 10.0085 15.7849 9.71914L14.0876 8.26521C13.0909 7.41138 12.6556 6.07166 12.9601 4.79501L13.4786 2.6211C13.5818 2.18849 13.1112 1.84656 12.7317 2.07839L10.8244 3.24334C9.70433 3.92747 8.29567 3.92747 7.17561 3.24334L5.26834 2.07839C4.88879 1.84656 4.41817 2.18849 4.52136 2.6211L5.03992 4.79501C5.34444 6.07166 4.90914 7.41138 3.91238 8.26521L2.21507 9.71914C1.8773 10.0085 2.05706 10.5617 2.50039 10.5973L4.72815 10.7759C6.03641 10.8808 7.17604 11.7087 7.68007 12.9206L8.53834 14.9841C8.70914 15.3947 9.29086 15.3947 9.46166 14.9841Z",
    fill: "#F1C644",
    stroke: "#F1C644",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star_filled.0967005ab71b1ba50deb97ae144a335b.svg";
export { ForwardRef as ReactComponent };